import React from 'react';
import getHostDomain from 'helpers/getHostDomain';

import SplitPageContainer from 'components/SplitPageContainer';
import SplitPageRight from 'components/SplitPageRight';
import PictureCard from 'components/molecules/PictureCard';
import ViewOrgChart from 'pages/InviteTokenLanding/assets/ViewOrgChart.png';
import ViewProfile from 'pages/InviteTokenLanding/assets/ViewProfile.png';
import ViewBigSearch from 'pages/InviteTokenLanding/assets/ViewBigSearch.png';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

function DemoDataEnabled() {
  const classes = useStyles();
  const hostDomain = getHostDomain();

  return (
    <SplitPageContainer>
      <SplitPageRight>
        <Typography className={classes.headline}>Where would you like to start?</Typography>
        <Typography className={classes.textBody}>
          To make things easier, we’ve already set you up with demo people data. Here are some of
          the features you can explore:
        </Typography>
        <div className={classes.container}>
          <PictureCard
            src={ViewOrgChart}
            linkText={'View the org chart'}
            alt={'Organization chart'}
            url={`https://app.${hostDomain}.com/orgchart`}
          />
          <PictureCard
            src={ViewProfile}
            linkText={'Check out a profile'}
            alt={'Profile'}
            url={`https://app.${hostDomain}.com/person/email/lfindlow11@tychoengineering.com`}
          />
          <PictureCard
            src={ViewBigSearch}
            linkText={'Try out big search'}
            alt={'Big Search'}
            url={`https://app.${hostDomain}.com/`}
          />
        </div>
        <Typography className={classes.textFooter}>
          If you’d like to add your own people data or customize Sift further, you can do so by
          accessing the Admin Dashboard.
        </Typography>
        <Button
          className={classes.button}
          variant="outlined"
          href={`https://app.${hostDomain}.com/admin`}
          target="_blank"
        >
          Go to admin dashboard
        </Button>
      </SplitPageRight>
    </SplitPageContainer>
  );
}

const useStyles = makeStyles(theme => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      marginTop: theme.spacing(5.25),

      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(5.25),
        flexDirection: 'column',
        alignItems: 'center',
      },
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
      },
    },
    headline: {
      fontSize: 34,
      lineHeight: '42.74px',
      letterSpacing: '0.25px',
      height: 43,
      marginBottom: theme.spacing(1),
      [theme.breakpoints.down('lg')]: {
        fontSize: 24,
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(1),
        fontSize: 20,
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(0.5),
        fontSize: 14,
      },
    },
    textBody: {
      fontSize: 16,
      lineHeight: '28px',
      letterSpacing: '0.5px',
      marginBottom: theme.spacing(6),
      height: 24,
      [theme.breakpoints.down('lg')]: {
        marginBottom: theme.spacing(3),
        fontSize: 14,
      },
      [theme.breakpoints.down('md')]: {},
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(1),
        fontSize: 12,
      },
    },
    textFooter: {
      marginTop: theme.spacing(6),
      [theme.breakpoints.down('lg')]: {
        marginBottom: theme.spacing(3),
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(1),
      },
    },
    button: {
      marginTop: theme.spacing(3.875),
    },
  };
});

export default DemoDataEnabled;
